<template>
	<el-dialog :title="titles[source]" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
		<h2 v-if="source == 'allocatePartners'" class="mt-6 mb-16 yx-color-black fz-16">
			您已经选择
			<span class="yx-color-orange-2 fz-18">{{ drnums }}</span>
			个达人
		</h2>
		<div class="title" style="color: #86909d">
			<span>请选择要分配的员工，分配后由员工继续跟进合作。</span>
			<span v-if="source == 'allocatePartners'">
				若达人存在多人跟进则多跟进人数据会一起转移给新跟进人，若仅需转移达人的某个跟进人数据可前往[我的达人]操作
			</span>
		</div>
		<div class="mb-16 flex">
			<el-input class="mr-16" v-model="partner_role_name" clearable placeholder="请输入员工名称" />
			<el-button type="primary" @click="onSearch">搜索</el-button>
		</div>
		<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column min-width="40">
				<template v-slot="{ row }">
					<el-radio v-model="user_id" :label="row.user_id">{{ '' }}</el-radio>
				</template>
			</el-table-column>
			<el-table-column label="员工名称" min-width="170">
				<template v-slot="{ row }">
					<div class="flex flex-align-center">
						<yx-avatar size="small" :src="row.avatar_url"></yx-avatar>
						<p class="ml-6">{{ row['partner_name'] }}</p>
						<el-tag v-if="row.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
						<el-tag class="ml-8" v-else-if="row.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="手机号" min-width="150"></el-table-column>
			<el-table-column prop="anchor_count" label="当前跟进达人数" min-width="140"></el-table-column>
		</el-table>
		<yx-pagination
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			@size-change="sizeChange"
			@current-change="currentChange"
		/>
		<span slot="footer">
			<el-button type="primary" :loading="loading" @click="submit">确认分配</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { getPartnerList, teamSeaAllot, importTalents } from '@/api/talentCRM';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'allocationDialog',
	props: {
		drnums: {
			type: Number,
			default: 0,
		},
		anchorIds: {
			type: Array,
			default: () => [],
		},
		platform_id: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			dialogVisible: false,
			anchor_id: 0,
			user_id: 0,
			partner_role_name: '',
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			titles: {
				allocatePartner: '分配员工',
				allocatePartners: '批量分配/重新分配',
			},
			noCooperTalent: 0,
			cooperTalent: 0,
			source: '',
			anchor_msg: [],
			loading: false,
		};
	},
	computed: {
		anchor_ids: {
			get() {
				return this.anchorIds.map(item => item.anchor_id).join(',');
			},
			set() {},
		},
	},
	methods: {
		show(anchor_id, from_partner_id, source) {
			this.getPartnerList();
			this.anchor_id = anchor_id;
			this.dialogVisible = true;
			this.source = source;
		},
		Show(anchor_msg, source) {
			this.getPartnerList();
			this.source = source;
			this.anchor_msg = anchor_msg;
			this.dialogVisible = true;
		},
		handleClose() {
			this.anchor_id = this.user_id = 0;
			this.anchor_ids = '';
			this.partner_role_name = '';
			this.dialogVisible = false;
		},
		async getPartnerList() {
			const { partner_role_name } = this;
			const { code, data: { list = [], page = {} } = {} } = await getPartnerList({
				partnerName: partner_role_name,
				...this.pageInfo,
			});
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total;
			this.user_id = 0;
		},
		onSearch() {
			this.pageInfo.page_index = 1;
			this.getPartnerList();
		},
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getPartnerList();
		},
		currentChange(index) {
			this.pageInfo.page_index = index;
			this.getPartnerList();
		},
		async submit() {
			const { anchor_id, user_id, platform_id } = this;
			if (!user_id) return this.$message.error('请选择要分配的员工');
			this.loading = true;
			try {
				if (this.source === 'allocatePartner') {
					await teamSeaAllot({ anchor_id, to_user_id: user_id });
					this.$message.success('分配成功');
				} else {
					const select_anchors = this.anchor_msg.map(({ anchor_id }) => ({ anchor_id, from_user_id: '' }));
					await importTalents({ select_anchors, platform_id, to_user_id: user_id });
					const h = this.$createElement;
					this.$message({
						message: h('div', null, [
							h('i', { class: 'el-icon-warning', style: 'color:#2475FF;margin-right:6px' }, null),
							h('span', { style: 'color:black' }, '批量重新分配操作后，系统处理时间可能较长，您可在【分配记录】中查看分配结果'),
						]),
						type: null,
					});
				}
				this.$emit('getList');
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
	},
	components: {},
};
</script>

<style lang="less" scoped>
.title {
	font-size: 14px;
	color: #1d1f23;
	margin-bottom: 12px;
}
/deep/ .el-radio {
	margin-left: 6px;
}
/deep/ .el-radio .el-radio__label {
	display: inherit;
}
/deep/ .el-table__body-wrapper {
	height: 300px;
	overflow-y: auto;
}
/deep/ .el-dialog__body {
	padding-bottom: 0px !important;
}
/deep/ .el-dialog__footer {
	padding-top: 0px;
}
</style>
